import type PlayClient from '@empathybroker/tsclient-play'
import type { Auth } from '@empathybroker/tsclient-play/dist/models/auth'
import type { PlayResponse } from '@empathybroker/tsclient-play/dist/models/play-response'

import type { ActionContext } from 'vuex'

import type { ActionClass, AuthState } from '../../../models'
import type { StorageService } from '../../../services'

import { CONTAINER } from '../../../config'

import { TYPES } from '../../../config/inversify.types'

import { AUTH_CONSTS } from '../../auth/auth.consts'

export class RefreshAction implements ActionClass {
  static async execute(
    this: void,
    { state, commit }: ActionContext<AuthState, any>,
  ): Promise<string> {
    const playClient: PlayClient = CONTAINER.get<() => PlayClient>(TYPES.PlayClient)()
    try {
      const playResponse: PlayResponse = await playClient.refresh(state.refreshToken)
      const playResponseData = playResponse.data as Auth
      const token = playResponseData.accessToken
      const refreshToken = playResponseData.refreshToken
      commit(AUTH_CONSTS.mutations.setState, {
        token,
        refreshToken,
      })
      const storageService: StorageService = CONTAINER.get<StorageService>(TYPES.StorageService)
      storageService.setItem(AUTH_CONSTS.storage.token, token)
      storageService.setItem(AUTH_CONSTS.storage.refreshToken, refreshToken)
      return token
    } catch (error) {
      throw error
    }
  }
}
